import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
} from "Components/ui/dialog";
import { Separator } from "Components/ui/separator";
import React from "react";

function PopUp({ open, setOpen, title, children, width, className }) {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        className="md:max-w-[55%] max-w-[90%]  overflow-x-hidden shadow-xl
      "
        style={{
          width: width && width,
        }}
      >
        <DialogHeader className="font-N_Medium text-2xl">
          {title}
        </DialogHeader>
        <Separator className="bg-grey-dark w-[120%] ml-[-10%] opacity-20 h-[0.2rem] rounded-xl" />
        <DialogDescription
          className={`flex flex-row justify-between gap-8 ${className}`}
        >
          {children}
        </DialogDescription>
      </DialogContent>
    </Dialog>
  );
}

export default PopUp;
